<template>
  <el-dialog
    title="如何绑定抖音号发布图文"
    :visible.sync="visible"
    width="680px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="douyin-bind-guide-dialog"
  >
    <div class="bind-guide">
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="绑定抖音号后，才可在抖店后台发布挂车图文，获得更多曝光。"
        class="mgb14"
      />

      <div class="bind-steps">
        <div class="bind-step">
          <div class="bind-step__num">1</div>
          <div class="bind-step__content">
            <div class="bind-step__title">打开抖店后台</div>
            <div class="bind-step__desc">
              使用浏览器登录抖店商家后台（fxg.jinritemai.com），左侧进入
              <strong>流量 → 图文运营</strong>，再点击 <strong>发布图文</strong>
            </div>
            <div class="bind-step__img-wrap">
              <el-image
                class="bind-step__img"
                :src="entryImg"
                :preview-src-list="[entryImg]"
                fit="contain"
                alt="图文运营入口示意"
              />
              <div class="bind-step__img-tip">点击图片可放大查看</div>
            </div>
          </div>
        </div>
        <div class="bind-step">
          <div class="bind-step__num">2</div>
          <div class="bind-step__content">
            <div class="bind-step__title">进入抖音账号管理</div>
            <div class="bind-step__desc">路径：店铺设置 / 账号相关 → <strong>抖音账号管理</strong></div>
          </div>
        </div>
        <div class="bind-step">
          <div class="bind-step__num">3</div>
          <div class="bind-step__content">
            <div class="bind-step__title">绑定抖音号</div>
            <div class="bind-step__desc">点击「绑定抖音号」，按页面提示完成授权绑定</div>
          </div>
        </div>
        <div class="bind-step">
          <div class="bind-step__num">4</div>
          <div class="bind-step__content">
            <div class="bind-step__title">去发布图文验证</div>
            <div class="bind-step__desc">
              绑定成功后，进入抖店后台「流量 → 图文运营 → 发布图文」。在发布页顶部
              <strong>账号</strong> 下拉中应能看到已绑定的抖音号，即可选择账号发布挂车图文。
            </div>
            <div class="bind-step__img-wrap">
              <el-image
                class="bind-step__img bind-step__img--preview"
                :src="guideImg"
                :preview-src-list="[guideImg]"
                fit="cover"
                alt="抖店发布图文界面"
              />
              <div class="bind-step__img-tip">点击图片可放大查看</div>
            </div>
            <div class="bind-preview__box">
              <div class="bind-preview__row">
                <span class="bind-preview__label">账号</span>
                <div class="bind-preview__select">
                  <i class="el-icon-user-solid"></i>
                  <span>请选择已绑定的抖音号</span>
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div class="bind-preview__hint">
                若此处为空或无法选择，说明尚未绑定成功，请返回第 2、3 步重新绑定。
              </div>
            </div>
          </div>
        </div>
        <div class="bind-step">
          <div class="bind-step__num">5</div>
          <div class="bind-step__content">
            <div class="bind-step__title">搬家模板勾选「同步发布图文」</div>
            <div class="bind-step__desc">
              打开软件 <strong>搬家设置 / 搬家模板</strong>，在「上架设置」中勾选
              <strong>同步发布图文</strong> 并保存。绑定抖音号后，日常上货将自动发布图文获取曝光。
            </div>
            <div class="bind-step__img-wrap">
              <el-image
                class="bind-step__img"
                :src="syncImg"
                :preview-src-list="[syncImg]"
                fit="contain"
                alt="搬家模板同步发布图文示意"
              />
              <div class="bind-step__img-tip">点击图片可放大查看</div>
            </div>
          </div>
        </div>
      </div>

      <div class="bind-tips">
        <div class="bind-tips__title">小贴士</div>
        <ul>
          <li>一个店铺可绑定多个抖音号，发布时按需切换账号</li>
          <li>务必在搬家模板勾选「同步发布图文」，日常上货才会辅助图文曝光</li>
          <li>建议每日稳定发布，更有利于店铺动销与流量加权</li>
        </ul>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="visible = false">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
import guideImg from "@/assets/img/guide/douyin-publish-text.png";
import entryImg from "@/assets/img/guide/douyin-tuwen-entry.png";
import syncImg from "@/assets/img/guide/douyin-sync-image-text.png";

export default {
  name: "DouyinBindGuide",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return { guideImg, entryImg, syncImg };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>

<style scoped>
.bind-guide {
  padding: 2px 2px 8px;
}
.mgb14 {
  margin-bottom: 14px;
}
.bind-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}
.bind-step {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.bind-step__num {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #67c23a;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}
.bind-step__title {
  font-size: 14px;
  font-weight: 650;
  color: #303133;
  margin-bottom: 4px;
}
.bind-step__desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
.bind-step__img-wrap {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  background: #fff;
  position: relative;
}
.bind-step__img {
  display: block;
  width: 100%;
  cursor: zoom-in;
}
.bind-step__img >>> .el-image__inner {
  width: 100%;
  cursor: zoom-in;
}
.bind-step__img--preview >>> .el-image__inner {
  max-height: 220px;
  object-fit: cover;
  object-position: top left;
}
.bind-step__img-tip {
  padding: 4px 8px;
  font-size: 12px;
  color: #909399;
  background: #fafafa;
  border-top: 1px solid #ebeef5;
}
.bind-preview__box {
  margin-top: 4px;
  padding: 14px;
  border-radius: 10px;
  border: 1px dashed #c2e7b0;
  background: #f0f9eb;
}
.bind-preview__row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bind-preview__label {
  width: 42px;
  font-size: 13px;
  color: #606266;
}
.bind-preview__select {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #909399;
  font-size: 13px;
}
.bind-preview__select .el-icon-arrow-down {
  margin-left: auto;
}
.bind-preview__hint {
  margin-top: 10px;
  font-size: 12px;
  color: #67c23a;
  line-height: 1.5;
}
.bind-tips {
  padding: 12px 14px;
  border-radius: 8px;
  background: #fafafa;
  border: 1px solid #ebeef5;
}
.bind-tips__title {
  font-size: 13px;
  font-weight: 650;
  color: #303133;
  margin-bottom: 6px;
}
.bind-tips ul {
  margin: 0;
  padding-left: 18px;
  color: #606266;
  font-size: 12px;
  line-height: 1.7;
}
.dialog-footer {
  text-align: right;
}
</style>
